export enum DropdownOldOnColor {
  onwhite = 'onwhite',
  ongrey = 'ongrey',
  onblueberry = 'onblueberry',
  oncherry = 'oncherry',
}
